/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Settings_Editor_Connected_SinceInputs */

const fr_settings_editor_connected_since = /** @type {(inputs: Settings_Editor_Connected_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Contributeur depuis le ${i?.date}`)
};

const en_settings_editor_connected_since = /** @type {(inputs: Settings_Editor_Connected_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Contributor since ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Contributor since {date}" |
*
* @param {Settings_Editor_Connected_SinceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_editor_connected_since = /** @type {((inputs: Settings_Editor_Connected_SinceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Editor_Connected_SinceInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_editor_connected_since(inputs)
	return en_settings_editor_connected_since(inputs)
});